<template>
  <div class="add-form">
    <Form ref="addForm" :model="form" :rules="diyData.rules" :label-width="100">
      <div class="tag-title">机构信息</div>
      <FormItem label="logo" prop="logo">
        <upload-file-one @on-success="uploadSuc($event, 1)" :defaultUrl="form.logo" tips=""></upload-file-one>
      </FormItem>
      <FormItem label="机构名称" prop="name">
        <Input v-model="form.name" placeholder="请输入机构名称" style="width: 440px"></Input>
      </FormItem>
      <FormItem label="合作方式" prop="type">
        <RadioGroup v-model="form.type">
          <Radio label="1">购买</Radio>
          <Radio label="2">服务</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="联系电话" prop="mobile">
        <Input v-model="form.mobile" placeholder="请输入联系电话" style="width: 440px"></Input>
      </FormItem>
      <FormItem label="机构状态" prop="status">
        <RadioGroup v-model="form.status">
          <Radio label="0">无效</Radio>
          <Radio label="1">有效</Radio>
          <Radio label="2">冻结</Radio>
        </RadioGroup>
      </FormItem>
      <div class="tag-title">账号信息</div>
      <FormItem label="用户名" prop="user_name">
        <Input v-model="form.user_name" placeholder="请输入用户名" style="width: 440px"></Input>
      </FormItem>
      <FormItem label="邮箱" prop="user_email">
        <Input v-model="form.user_email" placeholder="请输入邮箱" style="width: 440px"></Input>
      </FormItem>
      <FormItem label="账号状态" prop="user_status">
        <RadioGroup v-model="form.user_status">
          <Radio label="0">冻结</Radio>
          <Radio label="1">有效</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="联系微信" prop="wechat">
        <upload-file-one @on-success="uploadSuc($event, 2)" :defaultUrl="form.wechat" tips=""></upload-file-one>
      </FormItem>
      <!--            <FormItem label="邮箱验证码" prop="captcha">-->
      <!--                <Input type="text" style="width: 440px" v-model="form.captcha" placeholder="请输入验证码">-->
      <!--                    <span slot="append">-->
      <!--                      <Button type="primary" v-if="!diyDom.is_send" @click="sendCode">获取验证码</Button>-->
      <!--                      <Button v-else>{{ countDown }}秒后再试</Button>-->
      <!--                    </span>-->
      <!--                </Input>-->
      <!--            </FormItem>-->
      <FormItem label="密码" prop="password" :class="[query.id ? '' : 'ivu-form-item-required']">
        <Input
          :readonly="isReadOnly"
          @on-focus="changeType"
          type="password"
          v-model="form.password"
          placeholder="请输入密码"
          style="width: 440px"
        ></Input>
      </FormItem>
      <FormItem label="确认密码" prop="password_confirmation" :class="[query.id ? '' : 'ivu-form-item-required']">
        <Input
          :readonly="isReadOnly"
          @on-focus="changeType"
          type="password"
          v-model="form.password_confirmation"
          placeholder="请输入确认密码"
          style="width: 440px"
        ></Input>
      </FormItem>
      <div class="tag-title">机构菜单</div>
      <FormItem label="机构菜单" prop="menus">
        <Tree :data="apiData.apiAccessList" ref="tree" show-checkbox></Tree>
      </FormItem>
    </Form>
    <Button type="primary" style="width: 90px; margin-right: 20px" @click="submit">保存</Button>
    <Button style="width: 90px" @click="$router.go(-1)">取消</Button>
  </div>
</template>

<script>
  import { apiOrganizationAdd, apiOrganizationDetail, apiOrganizationUpdate } from '@/api/organization'
  import { apiAgencyMenuList } from '@/api/admin'
  import UploadFileOne from '_c/upload-custom/upload-file-one'

  export default {
    name: 'add-organization',
    components: {
      UploadFileOne,
    },
    data() {
      return {
        query: {},
        search: {},
        diyDom: {
          is_send: false,
          countDown: 0,
          timer: null,
        },
        isReadOnly: true, // 解决表单自动填充
        // 表单数据
        form: {
          name: '', // 机构名称
          mobile: '', // 联系电话
          type: '1', // 类型
          status: '1', // 状态
          user_name: '', // 用户名
          user_email: '', // 用户邮箱
          password: '', // 密码
          password_confirmation: '', // 确认密码
          logo: '',
          user_status: '1', // 账号状态
          menus: [],
          wechat: '',
        },
        diyData: {
          rules: {
            name: [{ required: true, message: '机构名称不能为空', trigger: 'blur' }],
            mobile: [{ required: true, message: '联系电话不能为空', trigger: 'blur' }],
            type: [{ required: true, message: '合作方式不能为空', trigger: 'change' }],
            status: [{ required: true, message: '机构状态不能为空', trigger: 'change' }],
            user_name: [{ required: true, message: '用户名不能为空', trigger: 'blur' }],
            user_status: [{ required: true, message: '账号状态不能为空', trigger: 'change' }],
            user_email: [{ required: true, message: '用户邮箱不能为空', trigger: 'change' }],
            // logo: [{ required: true, message: 'logo不能为空', trigger: 'change' }],
          },
          menuArr: [], // 反查询菜单
        },
        apiData: {
          apiAccessList: [],
        },
      }
    },
    computed: {},
    methods: {
      // 获取详情
      getDetail() {
        this.$store.commit('setSpinShow', true)
        apiOrganizationDetail(this.query.id)
          .then(res => {
            const { mobile, name, status, type, users, logo, menus, wechat } = res
            this.form.mobile = mobile
            this.form.name = name
            this.form.status = status + ''
            this.form.type = type + ''
            this.form.user_name = users.name
            this.form.user_email = users.email
            this.form.user_status = users.status + ''
            this.form.logo = logo
            this.form.wechat = wechat
            this.selectAuth(menus, this.apiData.apiAccessList)
          })
          .finally(() => this.$store.commit('setSpinShow', false))
      },

      uploadSuc(url, type) {
        if (type == 1) {
          this.form.logo = url.url
        } else {
          this.form.wechat = url.url
        }
      },

      // 发送验证码
      sendCode() {
        // apiGetCaptcha({
        //     email:this.form.email
        // }).then(res => {
        //     this.$Message.success('验证码发送成功，请注意查收')
        //     this.diyDom.countDown = 60;
        //     this.diyDom.is_send = true;
        //     this.diyDom.timer = setInterval(() => {
        //         if(this.diyDom.countDown == 0) {
        //             clearInterval(this.diyDom.timer)
        //             this.diyDom.is_send = false;
        //         }
        //         this.diyDom.countDown--;
        //     },1000)
        // })
      },
      // 解决自动填充表单
      changeType() {
        this.isReadOnly = false
      },

      // 获取菜单
      getTreeList() {
        apiAgencyMenuList().then(res => {
          this.dealAccessData(res)
        })
      },
      // 处理数据
      dealAccessData(data) {
        let map = {}
        data.forEach(item => {
          map[item.id] = item
        })
        data.forEach(item => {
          let parent = map[item.parent] //判断item的pid是否是否存在map中
          if (parent) {
            //如果存在则表示item不是最顶层的数据
            ;(parent.children || (parent.children = [])).push(item)
          } else {
            this.apiData.apiAccessList.push(item) // 如果不存在 则是顶层数据
          }
        })
        this.query.id && this.getDetail()
      },

      // 迭代选择的菜单
      selectAuth(menus, arr) {
        menus.forEach(item => {
          arr.forEach((citem, cindex) => {
            if (citem.id == item) {
              this.$set(arr[cindex], 'checked', true)
            }
            if (citem.children && citem.children.length > 0) {
              // 如果存在子菜单，把父菜单选择为空，不然会全部选择上，在提交的时候，用数组去重
              this.$set(arr[cindex], 'checked', false)
              this.selectAuth(menus, citem.children)
            }
          })
        })
      },

      // 迭代菜单,寻找父级菜单
      getMenuParentIid(form, menu) {
        this.diyData.menuArr = [...new Set(this.diyData.menuArr)]
        form.forEach(item => {
          menu.forEach(citem => {
            if (item == citem.id && citem.parent_id != 0) {
              this.diyData.menuArr.push(citem.parent_id)
            } else if (citem.children && citem.children.length > 0) {
              this.getMenuParentIid(form, citem.children)
            }
          })
        })
      },

      submit() {
        this.form.menus = []
        this.$refs.tree.getCheckedNodes().forEach(item => {
          if (item.parent_id && item.parent_id != 0) {
            this.form.menus.push(item.parent_id)
          }
          this.form.menus.push(item.id)
        })
        // 数组去重
        this.getMenuParentIid(this.form.menus, this.apiData.apiAccessList)
        // 数组去重
        this.form.menus = [...new Set([...this.form.menus, ...this.diyData.menuArr])].sort()

        this.$refs['addForm'].validate(valid => {
          if (valid) {
            const opt = {
              name: this.form.name,
              mobile: this.form.mobile,
              type: this.form.type,
              status: this.form.status,
              logo: this.form.logo,
              wechat: this.form.wechat,
              user: {
                name: this.form.user_name,
                email: this.form.user_email,
                password: this.form.password,
                password_confirmation: this.form.password_confirmation,
                status: this.form.user_status,
              },
              menus: this.form.menus,
            }
            if (opt.user.password == '') {
              delete opt.user.password
            }
            if (opt.user.password_confirmation == '') {
              delete opt.user.password_confirmation
            }
            if (this.query.id) {
              apiOrganizationUpdate(this.query.id, opt).then(() => {
                this.$Message.success('编辑机构成功')
                this.$router.replace({
                  name: 'organization-manage',
                })
              })
            } else {
              apiOrganizationAdd(opt).then(() => {
                this.$Message.success('新增机构成功')
                this.$router.replace({
                  name: 'organization-manage',
                })
              })
            }
          }
        })
      },
    },
    mounted() {
      this.query = this.$route.query
      this.getTreeList()
      if (!this.query.id) {
        this.diyData.rules.password = [{ required: true, message: '密码不能为空', trigger: 'blur' }]
        this.diyData.rules.password_confirmation = [{ required: true, message: '确认密码不能为空', trigger: 'blur' }]
      }
    },
  }
</script>

<style scoped lang="less">
  .add-form {
    border: 1px solid #ededed;
    margin: 0 20px;
    padding: 26px 20px;

    .title {
      border-left: 5px solid #2d8cf0;
      padding: 0 0 0 10px;
      margin: 0 20px 20px;
      font-weight: bold;
    }
  }
</style>
